import React, { useState, useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './exbation.css';
import Header from '../components/layout/header';
import Footer from '../components/layout/footer';
import Label from '../components/common/label';
import { Link } from "react-router-dom";
import as from '../asserts/ast.png';
import as1 from '../asserts/ast.png';
import ExhibitorCard from '../components/common/Exhibitorcard';
import Loader from '../components/layout/preloader';
import { supabase } from '../supabaseClient';

gsap.registerPlugin(ScrollTrigger);

const PRELOADER = 4.1;

const Exhibation = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchValue, setSearchValue] = useState('');
  const [categories, setCategories] = useState([]);
  const [exhibitors, setExhibitors] = useState([]);
  const [pageStatic, setPageStatic] = useState(null);
  const [dataReady, setDataReady] = useState(false);

  const as1Ref = useRef();
  const as2Ref = useRef();
  const labelRef = useRef();
  const titleRef = useRef();
  const textRef = useRef();
  const stat1Ref = useRef();
  const stat2Ref = useRef();
  const stat3Ref = useRef();
  const searchRef = useRef();
  const gridRef = useRef();
  const cardRefs = useRef([]);

  useEffect(() => {
    const fetchAll = async () => {
      const [catsRes, exRes, staticRes] = await Promise.all([
        supabase.from('categories').select('*'),
        supabase.from('exhibitors').select('*'),
        supabase.from('exhibitor_directory_static').select('*'),
      ]);
      setCategories(catsRes.data || []);
      setExhibitors(exRes.data || []);
      setPageStatic((staticRes.data || [])[0] || null);
      setDataReady(true);
    };
    fetchAll();
  }, []);

  useEffect(() => {
    if (!dataReady) return;

    const ctx = gsap.context(() => {

      [as1Ref.current, as2Ref.current].forEach(el => {
        if (el) el.style.animation = 'none';
      });

      if (as1Ref.current) {
        gsap.fromTo(as1Ref.current,
          { x: 260, y: -160, scale: 0.15, opacity: 0, rotation: 300 },
          { x: 0, y: 0, scale: 1, opacity: 1, rotation: 0, duration: 1.5, ease: 'expo.out', delay: PRELOADER }
        );
        gsap.to(as1Ref.current, { rotation: 360, duration: 7, repeat: -1, ease: 'none', delay: PRELOADER + 1.6 });
        gsap.to(as1Ref.current, { y: -22, duration: 3, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: PRELOADER + 1.8 });
      }

      if (as2Ref.current) {
        gsap.fromTo(as2Ref.current,
          { x: -260, y: -160, scale: 0.15, opacity: 0, rotation: -300 },
          { x: 0, y: 0, scale: 1, opacity: 1, rotation: 0, duration: 1.5, ease: 'expo.out', delay: PRELOADER + 0.1 }
        );
        gsap.to(as2Ref.current, { rotation: -360, duration: 9, repeat: -1, ease: 'none', delay: PRELOADER + 1.6 });
        gsap.to(as2Ref.current, { y: 22, duration: 3.6, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: PRELOADER + 2.1 });
      }

      if (labelRef.current) {
        gsap.fromTo(labelRef.current,
          { opacity: 0 },
          {
            duration: 0.9, delay: PRELOADER + 0.2,
            keyframes: [
              { opacity: 0, duration: 0.07 },
              { opacity: 1, duration: 0.07 },
              { opacity: 0, duration: 0.07 },
              { opacity: 0.4, duration: 0.07 },
              { opacity: 0, duration: 0.07 },
              { opacity: 1, duration: 0.55 },
            ]
          }
        );
      }

      if (titleRef.current) {
        gsap.fromTo(titleRef.current,
          { opacity: 0, letterSpacing: '24px', skewX: -9, y: -45 },
          { opacity: 1, letterSpacing: '2.95px', skewX: 0, y: 0, duration: 1.2, ease: 'expo.out', delay: PRELOADER + 0.35 }
        );
      }

      if (textRef.current) {
        gsap.fromTo(textRef.current,
          { opacity: 0, y: 30, filter: 'blur(10px)' },
          { opacity: 1, y: 0, filter: 'blur(0px)', duration: 1, ease: 'power3.out', delay: PRELOADER + 0.55 }
        );
      }

      const statEls = [stat1Ref.current, stat2Ref.current, stat3Ref.current].filter(Boolean);
      if (statEls.length) {
        gsap.fromTo(statEls,
          { scale: 0, opacity: 0, y: 35 },
          { scale: 1, opacity: 1, y: 0, duration: 0.85, stagger: 0.17, ease: 'elastic.out(1, 0.45)', delay: PRELOADER + 0.7 }
        );
      }

      if (searchRef.current) {
        gsap.fromTo(searchRef.current,
          { y: -55, scaleX: 0.5, opacity: 0, transformOrigin: 'center' },
          { y: 0, scaleX: 1, opacity: 1, duration: 0.95, ease: 'expo.out', delay: PRELOADER + 0.85 }
        );

        const input = searchRef.current.querySelector('.search-input');
        if (input) {
          input.addEventListener('focus', () =>
            gsap.to(searchRef.current.querySelector('.search-box'), { boxShadow: '0 0 0 2px rgba(255,30,30,0.5)', duration: 0.3 })
          );
          input.addEventListener('blur', () =>
            gsap.to(searchRef.current.querySelector('.search-box'), { boxShadow: '0 0 0 0px rgba(255,30,30,0)', duration: 0.3 })
          );
        }
      }

      gsap.fromTo('.filter-btn',
        { opacity: 0, y: 24, scale: 0.72 },
        { opacity: 1, y: 0, scale: 1, duration: 0.45, stagger: 0.055, ease: 'back.out(1.7)', delay: PRELOADER + 1.0 }
      );

      document.querySelectorAll('.filter-btn').forEach(btn => {
        btn.addEventListener('mouseenter', () => gsap.to(btn, { scale: 1.1, y: -2, duration: 0.2, ease: 'back.out(2)' }));
        btn.addEventListener('mouseleave', () => gsap.to(btn, { scale: 1, y: 0, duration: 0.35, ease: 'elastic.out(1, 0.4)' }));
      });

      const flyFrom = [
        { x: -120, y: 70, rotation: -12, rotateY: -25 },
        { x: 0, y: 110, rotation: 4, rotateY: 0 },
        { x: 120, y: 70, rotation: 12, rotateY: 25 },
        { x: -120, y: 70, rotation: -8, rotateY: -20 },
        { x: 0, y: 110, rotation: -4, rotateY: 0 },
        { x: 120, y: 70, rotation: 8, rotateY: 20 },
      ];

      cardRefs.current.forEach((card, i) => {
        if (!card) return;
        const d = flyFrom[i] ?? flyFrom[0];

        gsap.fromTo(card,
          { x: d.x, y: d.y, opacity: 0, scale: 0.75, rotation: d.rotation, rotateY: d.rotateY, filter: 'blur(8px)' },
          {
            x: 0, y: 0, opacity: 1, scale: 1, rotation: 0, rotateY: 0, filter: 'blur(0px)',
            duration: 1.05, ease: 'expo.out', delay: i * 0.14,
            scrollTrigger: { trigger: gridRef.current, start: 'top 80%' }
          }
        );

        card.addEventListener('mousemove', (e) => {
          const rect = card.getBoundingClientRect();
          const rx = ((e.clientY - rect.top) / rect.height - 0.5) * 24;
          const ry = ((e.clientX - rect.left) / rect.width - 0.5) * -24;
          gsap.to(card, { rotateX: rx, rotateY: ry, scale: 1.04, duration: 0.3, ease: 'power2.out', transformPerspective: 900, boxShadow: '0 32px 64px rgba(255,30,30,0.18)' });
        });

        card.addEventListener('mouseleave', () => {
          gsap.to(card, { rotateX: 0, rotateY: 0, scale: 1, duration: 0.7, ease: 'elastic.out(1, 0.4)', boxShadow: 'none' });
        });

        const img = card.querySelector('.exhibitor-card__img');
        if (img) {
          card.addEventListener('mouseenter', () => gsap.to(img, { filter: 'brightness(1.28) saturate(1.1)', duration: 0.4, ease: 'power2.out' }));
          card.addEventListener('mouseleave', () => gsap.to(img, { filter: 'brightness(1) saturate(1)', duration: 0.5 }));
        }
      });

      gsap.fromTo('.exhibitor-card__img-label',
        { scale: 0, opacity: 0 },
        { scale: 1, opacity: 1, duration: 0.5, stagger: 0.1, ease: 'back.out(2.2)', delay: 0.7, scrollTrigger: { trigger: gridRef.current, start: 'top 80%' } }
      );

    });

    return () => ctx.revert();
  }, [dataReady]);

  const filteredExhibitors = exhibitors.filter((ex) => {
    const matchCategory = activeCategory === 'all' || ex.category_slug === activeCategory;
    const matchSearch = ex.name.toLowerCase().includes(searchValue.toLowerCase()) ||
      ex.description.toLowerCase().includes(searchValue.toLowerCase());
    return matchCategory && matchSearch;
  });

  return (
    <>
      <Loader />
      <Header />

      <main>
        <section className='exhibitor-hero'>
          <div className='exhibitor-hero__inner'>

            <div className='exhibitor-hero__label-wrap' ref={labelRef} style={{ opacity: 0 }}>
              <Label labelt={pageStatic?.page_tag} />
            </div>

            <h1 className='e-title' ref={titleRef} style={{ opacity: 0 }}>
              {pageStatic?.page_title}
            </h1>

            <p className='e-text' ref={textRef} style={{ opacity: 0 }}>
              {pageStatic?.page_description}
            </p>

            <div className='exhibitor-hero__stats'>
              <div className='exhibitor-hero__stat' ref={stat1Ref} style={{ opacity: 0 }}>
                <span className='num'>{pageStatic?.stat_exhibitors_count}</span>
                <span className='num-text'>{pageStatic?.stat_exhibitors_label}</span>
              </div>
              <div className='exhibitor-hero__stat' ref={stat2Ref} style={{ opacity: 0 }}>
                <span className='num'>{pageStatic?.stat_categories_count}</span>
                <span className='num-text'>{pageStatic?.stat_categories_label}</span>
              </div>
              <div className='exhibitor-hero__stat' ref={stat3Ref} style={{ opacity: 0 }}>
                <span className='num'>{pageStatic?.stat_days_count}</span>
                <span className='num-text'>{pageStatic?.stat_days_label}</span>
              </div>

              <img src={as} alt="Interior design ornament" className='as' ref={as1Ref} style={{ opacity: 0 }} />
              <img src={as1} alt="Abstract design element" className='as1' ref={as2Ref} style={{ opacity: 0 }} />
            </div>

            <div className='exhibitor-hero__search-wrap' ref={searchRef} style={{ opacity: 0 }}>
              <div className='search-box'>
                <svg className='search-icon' xmlns='http://www.w3.org/2000/svg'
                  width='16' height='16' viewBox='0 0 24 24' fill='none'
                  stroke='rgba(255,255,255,0.87)' strokeWidth='2'
                  strokeLinecap='round' strokeLinejoin='round' aria-hidden="true">
                  <circle cx='11' cy='11' r='8' />
                  <line x1='21' y1='21' x2='16.65' y2='16.65' />
                </svg>
                <input
                  id="exhibitor-search"
                  className='search-input'
                  type='text'
                  placeholder={pageStatic?.search_placeholder}
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </div>
            </div>

            <div className='exhibitor-hero__filters' role="group" aria-label="Filter by category">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  className={`filter-btn${activeCategory === cat.slug ? ' filter-btn--active' : ''}`}
                  onClick={() => setActiveCategory(cat.slug)}
                  style={{ opacity: 0 }}
                  aria-pressed={activeCategory === cat.slug}
                >
                  {cat.name}
                </button>
              ))}
            </div>

            <p className='showing-text'>Showing {filteredExhibitors.length} exhibitors</p>
          </div>
        </section>

        <section className='exhibitor-grid' ref={gridRef}>
          <div className='exhibitor-grid__inner'>
            {filteredExhibitors.map((ex, i) => {
              const cardEl = (
                <div
                  key={ex.id}
                  ref={el => { cardRefs.current[i] = el; }}
                  style={{ opacity: 0 }}
                >
                  <Link to="/details" className='no-underline-link'>
                    <ExhibitorCard
                      imgSrc={ex.img_ee}
                      imgLabel={ex.location_id}
                      title={ex.name}
                      subtitle={ex.category_slug}
                      text={ex.description}
                    />
                  </Link>
                </div>
              );

              return ex.link
                ? <Link to={ex.link} className="no-underline-link" key={`link-${ex.id}`}>{cardEl}</Link>
                : cardEl;
            })}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Exhibation;